<template>
    <div>
        <div class="q-pt-md">
            <div>{{ $t('dashboards.filters.title') }}</div>
            <div
                class="q-gutter-md items-center"
            >
                <div>
                    <div
                        class="FormContainer"
                    >
                        <div :class="selectedFilter && selectedFilter.id === 'ACTIVITIES_DURATION' ? 'column' : 'row'">
                            <div
                                class="column"
                            >
                                <QSelect
                                    ref="filters"
                                    v-model="selectedFilter"
                                    :options="filters"
                                    :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectFilter')"
                                    stackLabel
                                    :disable="graphProps && !graphProps?.name"
                                    dense
                                    behavior="menu"
                                    outlined
                                    @update:modelValue="resetSelectors"
                                />
                                <QSelect
                                    v-if="selectedFilter && (
                                        (selectedFilter.kind === 'ACTIVITIES')
                                        || (selectedFilter.kind === 'ATTRIBUTE')
                                        || (selectedFilter.id === 'ACTIVITY_DURATION'))"
                                    ref="activities"
                                    v-model="selectedActivity"
                                    :label="activityLabel"
                                    :options="selectedFilter.kind === 'ATTRIBUTE' ? attributeActivities : activities"
                                    stackLabel
                                    dense
                                    outlined
                                    :rules="[value => validators.required(value)]"
                                    :multiple="!isSingleSelect"
                                >
                                    <template
                                        v-if="selectedFilter.id === 'TRACE_CONTAINS_ACTIVITIES' || selectedFilter.id === 'TRACE_NOT_CONTAINS_ACTIVITIES'"
                                        #option="{
                                            itemProps, opt, selected, toggleOption,
                                        }"
                                    >
                                        <QItem
                                            v-bind="itemProps"
                                            style="pointer-events: none;"
                                        >
                                            <QItemSection>
                                                <QItemLabel>{{ opt.label }}</QItemLabel>
                                            </QItemSection>
                                            <QItemSection side>
                                                <QToggle
                                                    :modelValue="selected"
                                                    :val="opt"
                                                    style="pointer-events: auto;"
                                                    @update:modelValue="toggleOption(opt)"
                                                />
                                            </QItemSection>
                                        </QItem>
                                    </template>
                                </QSelect>
                                <QSelect
                                    v-if="selectedFilter && ((selectedFilter.kind === 'ARCS') || (selectedFilter.id === 'ARC_DURATION'))"
                                    ref="arcs"
                                    v-model="selectedArc"
                                    :multiple="(
                                        selectedFilter.id === 'ARC_DURATION') ? false : true"
                                    :options="arcs"
                                    :rules="[value => validators.required(value)]"
                                    :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectArcs')"
                                    dense
                                    outlined
                                    stackLabel
                                >
                                    <template
                                        v-if="(selectedFilter.kind === 'ARCS')"
                                        #option="{
                                            itemProps, opt, selected, toggleOption,
                                        }"
                                    >
                                        <QItem
                                            v-bind="itemProps"
                                            style="pointer-events: none;"
                                        >
                                            <QItemSection>
                                                <QItemLabel>
                                                    {{ opt }}
                                                </QItemLabel>
                                            </QItemSection>
                                            <QItemSection side>
                                                <QToggle
                                                    :modelValue="selected"
                                                    :val="opt"
                                                    style="pointer-events: auto;"
                                                    @update:modelValue="toggleOption(opt)"
                                                />
                                            </QItemSection>
                                        </QItem>
                                    </template>
                                </QSelect>
                                <div
                                    v-if="selectedFilter && selectedFilter.kind === 'ATTRIBUTE'"
                                    class="row flex"
                                >
                                    <QSelect
                                        ref="attributes"
                                        v-model="selectedAttribute"
                                        dense
                                        outlined
                                        hideBottomSpace
                                        stackLabel
                                        behavior="menu"
                                        :rules="[value => validators.required(value)]"
                                        :options="attributesOptions"
                                        :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectAttribute')"
                                    >
                                        <QTooltip v-if="!attributesOptions">
                                            {{ $t('booster.alerts.definition.createScreen.triggerConditions.noAttributes') }}
                                        </QTooltip>
                                    </QSelect>
                                    <QSelect
                                        ref="attributeConstraints"
                                        v-model="attributeConstraints"
                                        dense
                                        outlined
                                        stackLabel
                                        :rules="[value => validators.required(value)]"
                                        :label="$t('booster.alerts.definition.createScreen.triggerConditions.constraints')"
                                        :options="ATTRIBUTTE_TYPES[selectedFilter.id]"
                                    />
                                    <QInput
                                        v-if="selectedFilter.id === 'NUMERIC_ATTRIBUTE'"
                                        ref="numericAttribute"
                                        v-model="attrValue"
                                        stackLabel
                                        :rules="[value => value >= 1 || $t('booster.alerts.definition.createScreen.triggerConditions.minValue')]"
                                        :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectValue')"
                                        type="number"
                                        :min="1"
                                        dense
                                        outlined
                                    />
                                    <QSelect
                                        v-if="selectedFilter.id === 'CATEGORICAL_ATTRIBUTE'"
                                        ref="categoricalAttribute"
                                        v-model="attrValue"
                                        :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectValue')"
                                        dense
                                        stackLabel
                                        outlined
                                        :rules="[value => validators.required(value)]"
                                        :options="(attrValues?.find(item => item.name === selectedAttribute)?.values)"
                                    />
                                    <QInput
                                        v-if="selectedFilter.id === 'DATETIME_ATTRIBUTE'"
                                        ref="dateAttribute"
                                        v-model="attrValue"
                                        outlined
                                        dense
                                        :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectDate')"
                                        type="date"
                                    />
                                </div>
                                <div
                                    v-if="selectedFilter && (selectedFilter.kind === 'DATETIME' || (selectedFilter.parameters?.[0]?.type === 'DATETIME'))"
                                    class="row flex"
                                >
                                    <QInput
                                        ref="time"
                                        v-model="selectedTime"
                                        dense
                                        outlined
                                        type="time"
                                        :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectTime')"
                                    />
                                    <QInput
                                        ref="date"
                                        v-model="selectedDate"
                                        dense
                                        outlined
                                        type="date"
                                        :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectDate')"
                                    />
                                </div>
                            </div>
                            <div
                                v-if="selectedFilter && selectedFilter.id === 'ACTIVITIES_DURATION'"
                                class="column flex"
                            >
                                <div class="row">
                                    <QRadio
                                        v-model="radioFilter"
                                        val="actOccurrence"
                                        label="By activity occurrence order"
                                    />
                                    <QRadio
                                        v-model="radioFilter"
                                        val="pairRepetition"
                                        label="By pair repetition"
                                    />
                                </div>
                                <div class="row">
                                    <QSelect
                                        v-if="radioFilter === 'actOccurrence'"
                                        ref="firstActivityConstraint"
                                        v-model="firstActivityConstraint"
                                        :options="ATTRIBUTTE_TYPES.OCCURRENCE_ATTRIBUTE"
                                        :label="$t('booster.alerts.definition.createScreen.triggerConditions.occurrenceOrder')"
                                        stackLabel
                                        :rules="[value => validators.required(value)]"
                                        dense
                                        outlined
                                    />
                                    <QSelect
                                        ref="firstActivity"
                                        v-model="firstActivity"
                                        :options="activities"
                                        :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectActivity')"
                                        stackLabel
                                        :rules="[value => validators.required(value)]"
                                        dense
                                        outlined
                                    />
                                </div>
                                <div class="row">
                                    <QSelect
                                        v-if="radioFilter === 'actOccurrence'"
                                        ref="secondActivityConstraint"
                                        v-model="secondActivityConstraint"
                                        :options="ATTRIBUTTE_TYPES.OCCURRENCE_ATTRIBUTE"
                                        :label="$t('booster.alerts.definition.createScreen.triggerConditions.occurrenceOrder')"
                                        stackLabel
                                        :rules="[value => validators.required(value)]"
                                        dense
                                        outlined
                                    />
                                    <QSelect
                                        ref="secondActivity"
                                        v-model="secondActivity"
                                        :options="activities"
                                        :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectActivity')"
                                        stackLabel
                                        :rules="[value => validators.required(value)]"
                                        dense
                                        outlined
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <QSelect
                                    v-if="selectedFilter && selectedFilter.kind === 'DURATION' && selectedFilter.id !== 'ACTIVITIES_DURATION'"
                                    ref="durationConstraints"
                                    v-model="durationConstraints"
                                    dense
                                    outlined
                                    stackLabel
                                    behavior="menu"
                                    :rules="[value => validators.required(value)]"
                                    :label="$t('booster.alerts.definition.createScreen.triggerConditions.constraints')"
                                    :options="DURATION_FILTERS.find(filter => filter.id === selectedFilter.id)?.options"
                                />
                                <QSelect
                                    v-if="selectedFilter && selectedFilter.kind === 'DURATION' && selectedFilter.id === 'ACTIVITIES_DURATION'"
                                    ref="durationConstraints"
                                    v-model="durationConstraints"
                                    dense
                                    outlined
                                    stackLabel
                                    behavior="menu"
                                    :rules="[value => validators.required(value)]"
                                    :label="$t('booster.alerts.definition.createScreen.triggerConditions.constraints')"
                                    :options="radioFilter === 'actOccurrence'
                                        ? DURATION_FILTERS.find(filter => filter.id === selectedFilter?.id)?.options
                                        : DURATION_FILTERS.find(filter => filter.id === selectedFilter?.id)?.loopOptions"
                                />
                                <QInput
                                    v-if="selectedFilter && selectedFilter.kind === 'DURATION'"
                                    ref="durationValue"
                                    v-model="selectedDurationValue"
                                    :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectValue')"
                                    type="number"
                                    :min="1"
                                    :rules="[value => value >= 1 || $t('booster.alerts.definition.createScreen.triggerConditions.minValue')]"
                                    stackLabel
                                    dense
                                    outlined
                                />
                                <QSelect
                                    v-if="selectedFilter && selectedFilter.kind === 'DURATION'"
                                    ref="durationUnit"
                                    v-model="selectedDurationUnit"
                                    dense
                                    outlined
                                    stackLabel
                                    :label="$t('booster.alerts.definition.createScreen.triggerConditions.selectUnit')"
                                    :options="timeUnits"
                                />
                            </div>
                        </div>
                    </div>
                    <QBtn
                        color="primary"
                        :label="$t('dashboards.filters.addFilter')"
                        :disable="graphProps && !graphProps?.name"
                        icon="filter_alt"
                        noCaps
                        dense
                        outline
                        class="q-ma-xs"
                        @click="addSelection"
                    />
                    <q-separator
                        class="q-mt-md q-mb-md"
                        color="primary"
                    />
                    <div class="q-mt-md q-mr-sm">
                        <QChip
                            v-for="(selection, index) in triggers"
                            :key="index"
                            :label="formatSelection(selection, allFilters, $t)"
                            color="primary"
                            textColor="white"
                            removable
                            class="Chip"
                            @remove="removeSelection(index)"
                        >
                            <QTooltip>
                                {{ formatSelection(selection, allFilters, $t) }}
                            </QTooltip>
                        </QChip>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import VueTypes from 'vue-types'
import { validatorsMixin } from '@/mixins'
import {
    Api, apiRequest, notifyError, notify,
} from '@/api'
import { serializeFilterForApi } from '@/utils/filters'
import { formatSelection } from '../utils'
import {
    ATTRIBUTTE_TYPES, CATEGOTY_ANY,
} from '../../Filters/FilterModal/filtersEntity'

export default {
    name: 'FiltersComponent',
    mixins: [validatorsMixin],
    props: {
        processId: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
        graphType: {
            type: String,
            required: true,
        },
        graphProps: {
            type: Object,
            required: true,
        },
        allFilters: VueTypes.oneOfType([VueTypes.object, VueTypes.array]),
        graphFilters: VueTypes.oneOfType([VueTypes.string, VueTypes.array]),
        dashboardFilters: VueTypes.object,
    },
    emits: ['update:triggers'],
    setup() {
        return {
            formatSelection,
        }
    },
    data() {
        return {
            unit: {
                value: 'M',
                label: this.$t('booster.alerts.definition.timeUnit.minutes'),
            },
            activities: [],
            attributes: [],
            filters: [],
            // Selected variables
            selectedFilter: undefined,
            selectedActivity: undefined,
            selectedArc: undefined,
            selectedAttribute: undefined,
            selectedTime: null,
            selectedDate: null,
            selectedDurationValue: undefined,
            selectedDurationUnit: undefined,

            durationConstraints: undefined,
            radioFilter: 'actOccurrence',
            firstActivity: undefined,
            firstActivityConstraint: undefined,
            secondActivity: undefined,
            secondActivityConstraint: undefined,
            attributeConstraints: [],
            attrValues: [],
            attrValue: [],
            triggers: [],
        }
    },
    computed: {
        timeUnits() {
            return [{
                value: 's',
                label: this.$t('booster.alerts.definition.timeUnit.seconds'),
            },
            {
                value: 'm',
                label: this.$t('booster.alerts.definition.timeUnit.minutes'),
            },
            {
                value: 'h',
                label: this.$t('booster.alerts.definition.timeUnit.hours'),
            },
            {
                value: 'd',
                label: this.$t('booster.alerts.definition.timeUnit.days'),
            },
            {
                value: 'M',
                label: this.$t('booster.alerts.definition.timeUnit.months'),
            },
            {
                value: 'y',
                label: this.$t('booster.alerts.definition.timeUnit.years'),
            },
            ]
        },
        attributesOptions() {
            if (this.selectedFilter.id === 'NUMERIC_ATTRIBUTE') {
                return this.filterAttributesByType(this.attributes, ['SHORT', 'INTEGER', 'LONG', 'DECIMAL'])
            }
            if (this.selectedFilter.id === 'BOOLEAN_ATTRIBUTE') {
                return this.filterAttributesByType(this.attributes, 'BOOLEAN')
            }
            if (this.selectedFilter.id === 'CATEGORICAL_ATTRIBUTE') {
                return this.filterAttributesByType(this.attributes, 'STRING')
            }
            if (this.selectedFilter.id === 'DATETIME_ATTRIBUTE') {
                return this.filterAttributesByType(this.attributes, 'TIMESTAMP')
            }
            return this.attributes
        },
        attributeActivities() {
            return [
                { label: CATEGOTY_ANY(), value: '' },
                ...this.activities,
            ]
        },
        isSingleSelect() {
            const singleIds = [
                'TRACE_STARTS_WITH_ACTIVITY',
                'TRACE_ENDS_WITH_ACTIVITY',
                'ACTIVITY_ENDS_AFTER',
                'ACTIVITY_ENDS_BEFORE',
                'ACTIVITY_STARTS_AFTER',
                'ACTIVITY_STARTS_BEFORE',
                'ACTIVITY_DURATION',
            ]
            return singleIds.includes(this.selectedFilter.id) || this.selectedFilter.kind === 'ATTRIBUTE'
        },
        activityLabel() {
            return this.isSingleSelect
                ? this.$t('booster.alerts.definition.createScreen.triggerConditions.selectActivity')
                : this.$t('booster.alerts.definition.createScreen.triggerConditions.selectActivities')
        },

    },
    beforeMount() {
        this.DURATION_FILTERS = [
            {
                label: this.$t('visualization.filters.duration.filters.trace'),
                kind: 'DURATION',
                id: 'TRACE_DURATION',
                options: [
                    { label: this.$t('visualization.filters.attributes.filters.greaterThan'), id: 'TRACE_DURATION_GREATER_THAN' },
                    { label: this.$t('visualization.filters.attributes.filters.lesserThan'), id: 'TRACE_DURATION_LESS_THAN' },
                ],
            },
            {
                label: this.$t('visualization.filters.duration.filters.activity'),
                kind: 'DURATION',
                id: 'ACTIVITY_DURATION',
                options: [
                    { label: this.$t('visualization.filters.attributes.filters.greaterThan'), id: 'ACTIVITY_DURATION_GREATER_THAN' },
                    { label: this.$t('visualization.filters.attributes.filters.lesserThan'), id: 'ACTIVITY_DURATION_LESS_THAN' },
                ],
            },
            {
                label: this.$t('visualization.filters.duration.filters.activities'),
                kind: 'DURATION',
                id: 'ACTIVITIES_DURATION',
                options: [
                    { label: this.$t('visualization.filters.attributes.filters.greaterThan'), id: 'ACTIVITIES_DURATION_GREATER_THAN' },
                    { label: this.$t('visualization.filters.attributes.filters.lesserThan'), id: 'ACTIVITIES_DURATION_LESS_THAN' },
                ],
                loopOptions: [
                    { label: this.$t('visualization.filters.attributes.filters.greaterThan'), id: 'ACTIVITIES_DURATION_LOOP_GREATER_THAN' },
                    { label: this.$t('visualization.filters.attributes.filters.lesserThan'), id: 'ACTIVITIES_DURATION_LOOP_LESS_THAN' },
                ],
            },
            {
                label: this.$t('visualization.filters.duration.filters.arc'),
                kind: 'DURATION',
                id: 'ARC_DURATION',
                options: [
                    { label: this.$t('visualization.filters.attributes.filters.greaterThan'), id: 'ARC_DURATION_GREATER_THAN' },
                    { label: this.$t('visualization.filters.attributes.filters.lesserThan'), id: 'ARC_DURATION_LESSER_THAN' },
                ],
            },
        ]
        this.ATTR_FILTERS = [
            {
                label: this.$t('visualization.filters.attributes.filters.numericalField'), kind: 'ATTRIBUTE', id: 'NUMERIC_ATTRIBUTE',
            },
            {
                label: this.$t('visualization.filters.attributes.filters.ctgField'), kind: 'ATTRIBUTE', id: 'CATEGORICAL_ATTRIBUTE',
            },
            {
                label: this.$t('visualization.filters.attributes.filters.booleanField'), kind: 'ATTRIBUTE', id: 'BOOLEAN_ATTRIBUTE',
            },
            {
                label: this.$t('visualization.filters.attributes.filters.dateTimeField'), kind: 'ATTRIBUTE', id: 'DATETIME_ATTRIBUTE',
            },
        ]
        this.ATTRIBUTTE_TYPES = {
            CATEGORICAL_ATTRIBUTE: ATTRIBUTTE_TYPES.CATEGORICAL_ATTRIBUTE(),
            BOOLEAN_ATTRIBUTE: ATTRIBUTTE_TYPES.BOOLEAN_ATTRIBUTE(),
            NUMERIC_ATTRIBUTE: ATTRIBUTTE_TYPES.NUMERIC_ATTRIBUTE(),
            DATETIME_ATTRIBUTE: ATTRIBUTTE_TYPES.DATETIME_ATTRIBUTE(),
            QUANTITY_ATTRIBUTE: ATTRIBUTTE_TYPES.QUANTITY_ATTRIBUTE(),
            OCCURRENCE_ATTRIBUTE: ATTRIBUTTE_TYPES.OCCURRENCE_ATTRIBUTE(),
        }
    },
    mounted() {
        this.getFilters()
        this.getAttributeValues()
        const normalizeList = (value) => (Array.isArray(value) ? value : (value ? [value] : []))

        if (!this.graphProps && this.dashboardFilters) {
            const list = normalizeList(this.dashboardFilters)
            this.triggers = list.map((f) => (serializeFilterForApi(f) || f))
        }
        if (this.graphProps && this.graphFilters) {
            const list = normalizeList(this.graphFilters)
            this.triggers = list.map((f) => (serializeFilterForApi(f) || f))
        }
    },
    methods: {
        addSelection() {
            let selFilter = {}
            if (this.selectedFilter) {
                if (this.selectedFilter.kind === 'ATTRIBUTE') {
                    selFilter = {
                        id: this.attributeConstraints?.value,
                        activity: Array.isArray(this.selectedActivity) ? this.selectedActivity[0].value : this.selectedActivity?.value,
                        attribute: this.selectedAttribute,
                        ...(this.selectedFilter.id !== 'BOOLEAN_ATTRIBUTE' && { values: [this.attrValue] }),
                    }
                }
                if (this.selectedFilter.kind === 'ACTIVITIES' || this.selectedFilter.kind === 'ARCS') {
                    const selected = this.selectedFilter.kind === 'ACTIVITIES'
                        ? this.selectedActivity
                        : this.selectedArc

                    const datetimeIds = [
                        'ACTIVITY_ENDS_AFTER',
                        'ACTIVITY_ENDS_BEFORE',
                        'ACTIVITY_STARTS_AFTER',
                        'ACTIVITY_STARTS_BEFORE',
                    ]

                    if (datetimeIds.includes(this.selectedFilter.id)) {
                        const dateTime = this.selectedDate && this.selectedTime
                            ? `${this.selectedDate}T${this.selectedTime}:00`
                            : null
                        selFilter = {
                            id: this.selectedFilter.id,
                            activity: selected[0]?.value || selected.value,
                            values: [dateTime],
                        }
                    } else {
                        selFilter = {
                            id: this.selectedFilter.id,
                            values: Array.isArray(selected)
                                ? selected.map((opt) => opt.value ?? opt)
                                : [selected?.value ?? selected],
                        }
                    }
                }
                if (this.selectedFilter.kind === 'DATETIME') {
                    selFilter = {
                        id: this.selectedFilter.id,
                        values: (this.selectedDate && this.selectedTime)
                            ? [`${this.selectedDate}T${this.selectedTime}:00`]
                            : undefined,
                    }
                }
                if (this.selectedFilter.kind === 'DURATION' && this.selectedDurationValue && this.selectedDurationUnit) {
                    const durationValue = this.toJavaCompatibleDuration(this.selectedDurationValue, this.selectedDurationUnit?.value)
                    const base = { id: this.durationConstraints?.id }

                    if (this.selectedFilter.id === 'TRACE_DURATION') {
                        selFilter = { ...base, values: [durationValue] }
                    } else if (this.selectedFilter.id === 'ACTIVITY_DURATION') {
                        selFilter = { ...base, activity: this.selectedActivity.value, values: [durationValue] }
                    } else if (this.selectedFilter.id === 'ARC_DURATION') {
                        selFilter = { ...base, arc: this.selectedArc, values: durationValue }
                    } else {
                        // eslint-disable-next-line no-lonely-if
                        if (this.radioFilter === 'actOccurrence') {
                            selFilter = {
                                ...base,
                                values: [
                                    this.firstActivity?.value,
                                    this.firstActivityConstraint?.value,
                                    this.secondActivity?.value,
                                    this.secondActivityConstraint?.value,
                                    durationValue,
                                ],
                            }
                        } else {
                            selFilter = {
                                ...base,
                                values: [
                                    this.firstActivity?.value,
                                    this.secondActivity?.value,
                                    durationValue,
                                ],
                            }
                        }
                    }
                }
            }
            const candidate = serializeFilterForApi(selFilter) || selFilter
            const isDuplicate = this.triggers.some((trigger) => trigger.id === candidate.id
                && JSON.stringify(trigger.values) === JSON.stringify(candidate.values))

            if (!this.hasEmptyFields(candidate) && !isDuplicate) {
                this.triggers.push(candidate)
                this.$emit('update:triggers', this.triggers)
                this.resetSelectors()
                this.selectedFilter = undefined
            }
            if (isDuplicate) {
                notify({ message: this.$t('dashboards.filters.addedFilter') })
            }
        },

        hasEmptyFields(obj) {
            return Object.keys(obj).length === 0
            || Object.values(obj).some((value) => value === undefined
            || value === null
            || (Array.isArray(value) && (value.length === 0 || value.some((v) => v === undefined || v === null || v === '')))
            || (typeof value === 'object' && value !== null && this.hasEmptyFields(value)))
        },
        removeSelection(index) {
            this.triggers.splice(index, 1)
            this.$emit('update:triggers', this.triggers)
        },
        filterAttributesByType(attributes, type) {
            const typeList = Array.isArray(type) ? type : [type]
            const attributesArray = Object.entries(attributes)
            return attributesArray
                .filter((entry) => typeList.includes(entry[1]))
                .map((entry) => entry[0])
        },
        async getAttributeValues() {
            const { processId } = this.$route.params
            const params = { filters: [], filterSets: [], arcs: true }
            apiRequest(Api().alerts.getAlertTriggers({ processId, params }))
                .then((data) => {
                    this.arcs = data.splitFilteredActivities.allArcs
                    this.activities = [...data.splitFilteredActivities.allActivities.map((act) => ({
                        label: act,
                        value: act,
                    }))
                        .sort((a, b) => a.label.localeCompare(b.label))]
                    this.attrValues = data.attributeValues
                    this.attributes = data.attributeTypes
                })
                .catch(notifyError)
        },

        async getFilters() {
            const kindsToInclude = ["ACTIVITIES", "ARCS", "DATETIME"]
            const filtersByType = this.allFilters.reduce((acc, item) => {
                if (kindsToInclude.includes(item.kind)) {
                    return {
                        ...acc,
                        [item.kind]: [
                            ...(acc[item.kind] || []),
                            item,
                        ],
                    }
                }
                return acc
            }, {})
            const allLabels = { ...filtersByType, ATTRIBUTES: this.ATTR_FILTERS, DURATION: this.DURATION_FILTERS }
            this.filters = Object.values(allLabels)
                .flat()
        },
        resetSelectors() {
            const allFields = [
                'selectedActivity', 'selectedArc', 'selectedAttribute', 'selectedTime', 'selectedDate',
                'selectedDurationValue', 'selectedDurationUnit', 'firstActivity', 'secondActivity',
                'attrValue', 'durationConstraints', 'firstActivityConstraint', 'secondActivityConstraint',
                'attributeConstraints']
            allFields.forEach((field) => {
                this[field] = undefined
            })
        },
    },
}
</script>
<style scoped lang="scss">
.toggle {
    border: 1px solid $primary
}
.AlertTypes {
    padding: 0;
}
.q-select {
    min-width: 150px;
    width:fit-content;
    max-width:500px;
    margin-right: 5px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.q-input {
    margin-right: 5px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.Chip {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.FormContainer {
    display:flex;
    align-items:center;

    .q-field--with-bottom {
        padding-bottom: 0px;
    }
}
.AddIconStyle {
    display:flex;
    margin-top: 18px;
    cursor:pointer;
}
</style>
